import {
  MERCADOPAGO_ERROR,
  MERCADOPAGO_LOADING,
  MERCADOPAGO_SUCCESS,
  MERCADOPAGO_RESET,
  MERCADOPAGO_REFERENCIA,
  MERCADOPAGO_REFERENCIA_LOADING,
} from "../../ActionTypes";
import axiosLogin from "global/helpers/axiosLogin";

export const wsGetMercadoPagoTurnosQr = (idturno, nextStep) => (dispatch) => {
  dispatch({
    type: MERCADOPAGO_LOADING,
  });
  axiosLogin().then((respuesta) => {
    respuesta
      .get(`/his/turnos/qr/${idturno}`)
      .then((res) => {
        if (nextStep) nextStep(true, res.data);

        dispatch({
          type: MERCADOPAGO_SUCCESS,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (nextStep) nextStep(false, err?.response?.data);
        let error = {
          detail: err.response
            ? err.response.data
            : "Error al contactar el server.",
          origen: "mercadoPagoTurnos",
        };

        dispatch({
          type: MERCADOPAGO_ERROR,
          payload: error,
        });
      });
  });
};

export const wsGetMercadoPagoLaboratorioQr =
  (idprotocolo, funLoading) => (dispatch) => {
    dispatch({
      type: MERCADOPAGO_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/lis/laboratorio/${idprotocolo}/-1`)
        .then((res) => {
          funLoading(true, res.data);
          dispatch({
            type: MERCADOPAGO_SUCCESS,
            payload: res.data,
          });
        })
        .catch((err) => {
          funLoading(true, err?.response?.data);
          funLoading(false);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "mercadoPagoLaboratorio",
          };

          dispatch({
            type: MERCADOPAGO_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsGetMercadoPagoReferencia =
  (referencia, nextStep) => (dispatch) => {
    dispatch({
      type: MERCADOPAGO_REFERENCIA_LOADING,
    });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/his/turnos/qr/referencia/${referencia}`)
        .then((res) => {
          if (nextStep) nextStep(true, res.data);
          dispatch({
            type: MERCADOPAGO_REFERENCIA,
            payload: res.data,
          });
        })
        .catch((err) => {
          if (nextStep) nextStep(false);
          let error = {
            detail: err.response
              ? err.response.data
              : "Error al contactar el server.",
            origen: "mercadoPagoLaboratorio",
          };

          dispatch({
            type: MERCADOPAGO_ERROR,
            payload: error,
          });
        });
    });
  };

export const wsGetMercadoPago =
  (idTurno, idProtocolo, nextStep) => (dispatch) => {
    dispatch({ type: MERCADOPAGO_LOADING });

    axiosLogin().then((respuesta) => {
      respuesta
        .get(`/shared/mercadopago-checkin/checkinQR/${idTurno}/${idProtocolo}`)
        .then((resp) => {
          dispatch({ type: MERCADOPAGO_SUCCESS, payload: resp.data });
          if (nextStep) nextStep(true, resp.data);
        })
        .catch((err) => {
          dispatch({ type: MERCADOPAGO_ERROR, payload: err });
          if (nextStep) nextStep(false, err);
        });
    });
  };

export const mercadoPagoReset = () => (dispatch) => {
  dispatch({
    type: MERCADOPAGO_RESET,
  });
};
